module.exports = __webpack_public_path__ + "static/img/partner17.b53fc5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/partner17.png
// module id = uKbz
// module chunks = 0